export const hiLoTypes = {
  hi: 'hi',
  lo: 'lo',
  HIGH: 'HIGH',
  LO: 'LO',
};
